import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-22 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16 reveal">
          <SectionLabel label={businessToolData.about.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
            {businessToolData.about.title}
          </h2>
          <div className="space-y-3">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-bold">
              {businessToolData.about.description}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {businessToolData.about.description2}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {businessToolData.about.description3}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {businessToolData.about.description4}
            </p>
          </div>
        </div>

        <div className="reveal max-w-2xl mx-auto">
          <div className="relative">
            {businessToolData.about.flowSteps.map((step, idx) => (
              <div key={idx} className="flex items-center gap-4">
                <div className="flex flex-col items-center">
                  <div className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold font-heading flex-shrink-0">
                    {idx + 1}
                  </div>
                  {idx < businessToolData.about.flowSteps.length - 1 && (
                    <div className="w-px h-8 bg-primary-200" />
                  )}
                </div>
                <div className="py-2">
                  <p className="text-sm md:text-base text-foreground-800 font-medium">
                    {step}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <div className="inline-block px-6 py-3 rounded-full bg-primary-50 border border-primary-200/60">
              <p className="text-sm md:text-base font-bold text-primary-700 font-heading">
                確認 → 整理 → 検討 → 設計 → 試す → 改善
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}